import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MESSAGE_TEXT ,BUTTON, SaveType, ButtonType, CHECKSHEETSETTINGDIALOG, DpadZoneType, Mode} from '@core/constants';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CheckSheetDisplayOrder, InputType, SortType } from '@core/models/enums';
import { cloneDeep } from 'lodash';
import { DialogTemplate, DropdownOption, InputParams, NyuShoDisplayConfigModel, SettingConfigModel } from '@core/models/models';
import { MarqueeSpeedService, SessionContextService, SessionStorageService } from '@core/services/common';
import { Utils, buildHeaderLogItems, pickLoggedFields } from '@core/helper';
import { functionalTrainingPositionDialog, LOCAL_STORAGE_KEY, nyushoGridConfig, nyushoPositionDialog, SESSION_STORAGE_KEY } from '@core/configs';
import { CheckSheetSettingHelper } from '@core/helper/check-sheet-setting.helper';
import { CommonHelper} from '@core/services/common';
import { prepareCheckSheetSettingForStorage } from '@core/helper/check-sheet-setting-storage.helper';
import { DeviceLicensesService } from '@core/services/apis';
import { SAUCER_LOG_ACTION } from '@core/configs';
import { SaucerLogService } from '@core/services/saucer-logs/saucer-log.service';

@Component({
  selector: 'caremoni-check-sheet-setting-dialog',
  templateUrl: './check-sheet-setting-dialog.component.html',
  styleUrls: ['./check-sheet-setting-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class CheckSheetSettingDialogComponent implements OnInit {

  @Input() headers: any[] = [];
  @Input() sortConfig: any = null;
  @Input() displayUnits: DropdownOption[] = [];
  @Input() displayGroups: DropdownOption[] = [];
  @Output() onSubmitHandler = new EventEmitter();
  @Input() isFlashingMoshiokuri: boolean = true;
  @Input() localStorageKey: string = LOCAL_STORAGE_KEY.settingDialog;
  @Input() headersStorageKey: string = LOCAL_STORAGE_KEY.settingDialogHeaders;
  @Input() sortConfigStorageKey: string = LOCAL_STORAGE_KEY.settingDialogSortConfig;
  @Input() screenStorageKey: string = '';

  DpadZoneType = DpadZoneType;
  inputParams: InputParams = {
    type: InputType.number,
    validate: false,
    readonly: false,
    disabled: false,
    maxLength: 100,
    borderFill: false,
    tabindex: 20
  };
  // default thời gian chuyển trang là 30 giây.
  timeChangePage: number = 30;
  buttonType = ButtonType;
  saveType = SaveType;
  SortType = SortType;
  BUTTON = BUTTON;
  MESSAGE_TEXT = MESSAGE_TEXT;
  CHECKSHEETSETTINGDIALOG = CHECKSHEETSETTINGDIALOG;
  dialogTemplate: DialogTemplate = new DialogTemplate();
  sortConfigDefault: SettingConfigModel = new SettingConfigModel();
  isNyuSho: boolean = true;
  isShortTimeSettingDialog: boolean = false;
  isFunctionalTrainingSettingDialog: boolean = false;
  currentConfig: SettingConfigModel = new SettingConfigModel();
  currentHeaders: any[] = [];
  // nyusho
  timeRanges: any[] = [6,5,4,3,2,1];
  timeRangeSelected: number = 6;
  marginToTimes: any[] = [0,5,10,15,30,45,60];
  marginToTimeSelected: number = 30;
  unitSelected: string[] = []; 
  groupSelected: string[] = []; 
  isSortByRoom: boolean = true;
  isSortByName: boolean = false;
  displayOrder = {
    name: CheckSheetDisplayOrder.Name,
    startTime: CheckSheetDisplayOrder.StartTime,
    endTime: CheckSheetDisplayOrder.EndTime
  } as const;
  nyuShoDisplayConfig : NyuShoDisplayConfigModel = new NyuShoDisplayConfigModel;
  sessionGroupData: DropdownOption[] = [];
  marqueeSpeedOptions: DropdownOption[] = [];
  marqueeSpeedRate: string = '';

  constructor(
    public config: DynamicDialogConfig,
    private sessionStorageService: SessionStorageService,
    private sessionContextService: SessionContextService,
    private checkSheetSettingHelper: CheckSheetSettingHelper,
    private deviceLicensesService: DeviceLicensesService,
    private marqueeSpeedService: MarqueeSpeedService,
    private saucerLogService: SaucerLogService,
  ) {
    }

  ngOnInit(): void {
    this.dialogTemplate.header = "設定";
    this.dialogTemplate.isModal = true;
    this.dialogTemplate.styleClass = 'check-sheet-setting-dialog';
    this.isShortTimeSettingDialog = this.screenStorageKey === LOCAL_STORAGE_KEY.settingDialogShortTime;
    this.isFunctionalTrainingSettingDialog = this.screenStorageKey === LOCAL_STORAGE_KEY.settingDialogFunctionalTraining;
    this.dialogTemplate.style = this.isFunctionalTrainingSettingDialog ? { width: '500px', height: '340px' } : { width: '500px' };
    this.dialogTemplate.hasBottom = true;

    let officeSelected = this.sessionContextService.getOfficeSelected<any>();
    this.isNyuSho = Utils.isNyusho(officeSelected.officeType);
    this.marqueeSpeedOptions = this.marqueeSpeedService.getSpeedOptions();
    this.marqueeSpeedRate = `${this.marqueeSpeedService.getSpeedRate()}`;
    
    if(!this.sortConfig || this.sortConfig?.length == 0) this.sortConfig =  cloneDeep(this.sortConfigDefault);
    // get data từ Session Storage
    this.getSetting();
    this.currentHeaders = this.processMealMoistureColumn(this.currentHeaders);
    if (!this.isNyuSho) {
      this.currentHeaders = this.checkSheetSettingHelper.processReasonLeaveColumn(this.currentHeaders);
    }
    this.saucerLogService.action(
      {},
      {
        action: SAUCER_LOG_ACTION.SETTING.VIEW
      }
    );
  }

  async onSubmit() {
    let submitDataTsuSho: any = { 
      headers: cloneDeep(this.currentHeaders),
      sortConfig: cloneDeep(this.currentConfig),
      timeChangePage: this.timeChangePage,
      isFlashingMoshiokuri: this.isFlashingMoshiokuri,
    };
    submitDataTsuSho.sortConfig.unitSelected = this.unitSelected;
    submitDataTsuSho.sortConfig.groupSelected = this.groupSelected;
    if (this.isShortTimeSettingDialog) {
      submitDataTsuSho.isShortTimeDefaultVisibilityInitialized = true;
    }

    this.nyuShoDisplayConfig = {
      ...this.nyuShoDisplayConfig,
      isSortByRoom: this.isSortByRoom,
      isSortByName: this.isSortByName,
      timeRangeSelected: this.timeRangeSelected,
      marginToTimeSelected: this.marginToTimeSelected,
      unitSelected: this.unitSelected,
      groupSelected: this.groupSelected
    };

    let snackMoiVisible = false;
    let snackMoiItem = this.currentHeaders.find(h => h.field == 'snack_moisture');
    if (snackMoiItem) snackMoiVisible = snackMoiItem.visible;

    let submitData: any = null;
    if (this.isNyuSho) {
      let headersToSave = this.currentHeaders.filter(h => h.field != 'snack_moisture');

      let submitDataNyuSho: any = {
        headers: cloneDeep(headersToSave),
        timeChangePage: this.timeChangePage,
        nyuShoDisplayConfig: this.nyuShoDisplayConfig,
        isFlashingMoshiokuri: this.isFlashingMoshiokuri,
        snackMoistureVisible: snackMoiVisible,
      };
      if (this.isFunctionalTrainingSettingDialog) {
        submitDataNyuSho.sortConfig = cloneDeep(this.nyuShoDisplayConfig);
      }
      submitData = submitDataNyuSho;
    } else {
      submitData = submitDataTsuSho;
    }

    this.marqueeSpeedService.setSpeedRate(this.marqueeSpeedRate);
    const oldSettingData = this.getSettingForCurrentScreen(this.getCurrentOfficeScreenSettings());
    await this.saveScreenConfig(submitData);
    this.onSubmitHandler.emit(submitData);
    this.logSettingUpdate(oldSettingData, submitData);
    this.logCloseDialog();
  }

  onChangeMarqueeSpeed(speedRate: any) {
    this.marqueeSpeedRate = speedRate;
  }

  onChangeTimeRange(event:any){
    this.timeRangeSelected = event;
  }
  
  onChangeMarginToTimes(event:any){
    this.marginToTimeSelected = event;
  }

  onChangeUnit(event:any){
    this.unitSelected = event;
    this.filterGroupByUnit(event);
    const validValues = this.displayGroups.map((x: any) => x.value);
    this.groupSelected = this.groupSelected.filter((g: any) => validValues.includes(g));
  }

  filterGroupByUnit(unitSelected: any[]) {
    this.displayGroups = this.checkSheetSettingHelper.filterGroupByUnit(unitSelected, this.sessionGroupData);
  }

  onChangeGroup(event:any){
    this.groupSelected = event
  }

  closeModal(){
    this.onSubmitHandler.emit(null);
    this.logCloseDialog();
  }

  // lưu setting vào local Storage
  async saveScreenConfig(data: any) {
    this.saveCurrentOfficeScreenSettings(this.prepareSettingForStorage(data), Mode.WEB);
  }


  // lấy data setting lưu từ local Storage
  async getSetting() {
    // use common helper get setting dialog
    this.sessionGroupData = this.sessionStorageService.getSessionData(LOCAL_STORAGE_KEY.groupData) || [];
    let settingData = this.getSettingForCurrentScreen(this.getCurrentOfficeScreenSettings());
    if(!settingData){
      this.currentConfig = cloneDeep(this.sortConfig)
      this.headers = this.headers?.filter((x:any) => !Utils.isNullOrEmpty(x.displayLbl));
      this.currentHeaders = cloneDeep(this.headers);
      //CKWEB-499
      if(this.isNyuSho)
        this.currentHeaders = this.handleHeaderColMoiSture(this.currentHeaders);
    }
    else {
      this.currentHeaders = settingData.headers;
      //CKWEB-499
      if(this.isNyuSho)
        this.currentHeaders = this.handleHeaderColMoiSture(this.currentHeaders);

      this.timeChangePage = settingData.timeChangePage;
      this.isFlashingMoshiokuri = settingData?.isFlashingMoshiokuri ?? true;
      if (this.isNyuSho) {
        this.timeRangeSelected = settingData?.nyuShoDisplayConfig?.timeRangeSelected;
        this.marginToTimeSelected = settingData?.nyuShoDisplayConfig?.marginToTimeSelected;
        this.unitSelected = settingData?.nyuShoDisplayConfig?.unitSelected;
        this.groupSelected = settingData?.nyuShoDisplayConfig?.groupSelected;
        this.isSortByName = settingData?.nyuShoDisplayConfig?.isSortByName;
        this.isSortByRoom = settingData?.nyuShoDisplayConfig?.isSortByRoom;
      } else {
        if (settingData?.sortConfig) {
          this.unitSelected = settingData?.sortConfig?.unitSelected;
          this.groupSelected = settingData?.sortConfig?.groupSelected;
          this.currentConfig = cloneDeep(settingData.sortConfig);
        }
      }

      if (!Array.isArray(this.unitSelected)) {
        if (this.unitSelected) {
          this.unitSelected = [this.unitSelected];
        } else {
          this.unitSelected = [];
        }
      }

      await this.filterGroupByUnit(this.unitSelected);

      if (!Array.isArray(this.groupSelected)) {
        if (this.groupSelected) {
          this.groupSelected = [this.groupSelected];
        } else {
          this.groupSelected = [];
        }
      }
    }

    if (this.isShortTimeSettingDialog) {
      this.normalizeDisplayOrderConfig();
    }
  }
  handleHeaderColMoiSture(currentHeaders: any[]) {
    if (!currentHeaders) {
      return [];
    }
    //Get snack field
    let colSnackMoi = currentHeaders?.find(f => f.field == 'snack');
    
    //Create temp objcd snack moisture
    let snackMoisture = {
      width: "5%",
      items: [{ title: 'おやつ水分' }],
      title: 'おやつ水分',
      field: 'snack_moisture',
      headerName: "おやつ水分",
      visible: colSnackMoi.hasSubHeader == null ? true : colSnackMoi.hasSubHeader
    };
    let indexSnackMoisture = currentHeaders.indexOf(snackMoisture);
    
    //In case config saved dynamo and fist load dialog
    if (indexSnackMoisture < 0) {
      let indexOfSnack = currentHeaders.indexOf(colSnackMoi);
      //Add temp object snack moisture to display header switch
      currentHeaders.splice(indexOfSnack + 1, 0, snackMoisture);
    }
    return currentHeaders;
  }

  processMealMoistureColumn(currentHeaders: any[]) {
    if (!currentHeaders || currentHeaders.length <= 0) {
      return [];
    }
    if (this.isNyuSho) {
      const colMeal = currentHeaders?.find(f => f.field == 'meal');
      const mealMoisture = nyushoGridConfig?.header?.find((m:any)=> m.field == "meal_moisture");
      const currentMealMoisture = currentHeaders?.find(crhd => crhd.field === "meal_moisture");
      if (!currentMealMoisture) {
        let idxMeal = currentHeaders.indexOf(colMeal);
        currentHeaders.splice(idxMeal + 1, 0, mealMoisture);
      }
      // sắp xếp lại vị trí config để hiện thị switch btn trên dialog
      const positionDialog = this.isFunctionalTrainingSettingDialog ? functionalTrainingPositionDialog : nyushoPositionDialog;
      let sortedHeader:any[] = [], findHeader;
      positionDialog.forEach(phd => {
        findHeader = currentHeaders.find(ch => ch.field === phd.field);
        if (findHeader) {
          sortedHeader.push(findHeader);
        }
      });

      if (sortedHeader.length > 0) currentHeaders = sortedHeader;
      
    }
    return currentHeaders;
  }

  onChangeSettingTime(timeChange: any) {
    if(!timeChange) return;
    this.timeChangePage = parseFloat(timeChange);
  }

  onFocusOutInput(event: any) {
    if (event.target.value < 10) {
      event.target.value = 10;
      this.onChangeSettingTime(10);
    }
  }

  onInputKeyDown(event: any) {
    if(event.key =='Enter') {
      const target = event.target as HTMLElement;
      // Lấy tất cả phần tử có tabindex
      const focusableElements: any[] = Array.from(document.querySelectorAll('[tabindex]')) as HTMLElement[] || [];
      if(focusableElements.length == 0) return;
      // Lọc ra những phần tử có tabindex lớn hơn phần tử hiện tại
      const nextElement: any = focusableElements
        // Chỉ lấy những phần tử có tabindex lớn hơn hiện tại
        .filter(el => el.tabIndex > target.tabIndex) 
        // Sắp xếp theo tabindex tăng dần và lấy phần tử đầu tiên
        .sort((a, b) => a.tabIndex - b.tabIndex)[0];
      
      // Focus vào phần tử tiếp theo nếu tồn tại
      if (nextElement) {
        nextElement.focus();
        event.preventDefault();
      }
    }
  }

  onNyuShoRadioClick(type: any) {
    this.isSortByRoom = (type === 'sortRoom');
    this.isSortByName = !this.isSortByRoom;
  }

  onDisplayOrderClick(order: CheckSheetDisplayOrder) {
    this.currentConfig.display_order = order;
    this.currentConfig.time_grouping_flg = order !== this.displayOrder.name;
    this.currentConfig.sorting_time = order === this.displayOrder.endTime ? this.displayOrder.endTime : this.displayOrder.startTime;
  }

  isDisplayOrderSelected(order: CheckSheetDisplayOrder): boolean {
    return this.currentConfig.display_order === order;
  }

  onCheckboxClick(type: any) {
    if(type == SortType.hidden_overtime_flg) {
      this.currentConfig.hidden_overtime_flg = !this.currentConfig.hidden_overtime_flg;
    }
    if(type == SortType.hidden_leave_user) {
      this.currentConfig.hidden_leave_user = !this.currentConfig.hidden_leave_user;
    }
  }

  // Tính toán số cột dựa trên độ dài của data
  get gridColumns(): string {
    // Functional training uses the 3-column layout from the design; other screens keep the existing 4-row layout.
    let numCols = this.isFunctionalTrainingSettingDialog ? 3 : Math.ceil(this.currentHeaders.length / 4);
    return `repeat(${numCols}, 1fr)`;
  }

  get gridRows(): string {
    const numRows = this.isFunctionalTrainingSettingDialog ? Math.ceil(this.currentHeaders.length / 3) : 3;
    return `repeat(${numRows}, 20px)`;
  }


  onChangeHeaderColumns(data: any) {
    this.currentHeaders?.forEach(hdItem => {
      if (hdItem.title == data.title) {
        hdItem.visible = !hdItem.visible;
      }
    });
    if (this.isNyuSho) {
      let snack = this.currentHeaders.find(f => f.field == 'snack');
      let snackMoi = this.currentHeaders.find(f => f.field == 'snack_moisture');
      snack.hasSubHeader = snackMoi.visible;
    }
  }
  getYTabDpad(index: number):number{
      return Math.floor(index / 3);
  }

  onChangeFlashingType() {
    this.isFlashingMoshiokuri = !this.isFlashingMoshiokuri;
  }

  private normalizeDisplayOrderConfig(): void {
    const displayOrder = this.currentConfig?.display_order;
    if (displayOrder === this.displayOrder.name || displayOrder === this.displayOrder.startTime || displayOrder === this.displayOrder.endTime) {
      this.onDisplayOrderClick(displayOrder);
      return;
    }

    const order = this.currentConfig?.time_grouping_flg && this.currentConfig?.sorting_time === this.displayOrder.endTime
      ? this.displayOrder.endTime
      : this.displayOrder.startTime;
    this.onDisplayOrderClick(order);
  }

  // #region Saucer Log
  onSaucerLogChangeTab(event: any) {
    const tabNameByValue: Record<string, string> = {
      '0': this.CHECKSHEETSETTINGDIALOG.DISPLAY_SETTING_NYUSHO,
      '1': this.CHECKSHEETSETTINGDIALOG.DISPLAY_COLUMN,
      '2': this.CHECKSHEETSETTINGDIALOG.SETTING_CONFIG
    };
    this.saucerLogService.action(
      {
        content: JSON.stringify({ tab: tabNameByValue[event] ?? event })
      },
      {
        action: SAUCER_LOG_ACTION.SETTING.CHANGE_TAB
      }
    );
  }

  private logSettingUpdate(oldSettingData: any, submitData: any): void {
    const fields = Object.keys(submitData);
    this.saucerLogService.action(
      {
        content: JSON.stringify({
          old: {
            ...pickLoggedFields(oldSettingData, fields),
            headers: buildHeaderLogItems(oldSettingData?.headers)
          },
          new: {
            ...pickLoggedFields(submitData, fields),
            headers: buildHeaderLogItems(submitData?.headers)
          }
        })
      },
      {
        action: SAUCER_LOG_ACTION.SETTING.UPDATE
      }
    );
  }

  private logCloseDialog(): void {
    this.saucerLogService.action(
      {},
      {
        action: SAUCER_LOG_ACTION.SETTING.CLOSE_DIALOG
      }
    );
  }
  // #endregion Saucer Log

  private getSettingForCurrentScreen(settingData: any): any {
    if (!settingData) return null;
    const screenSetting = this.getScreenSettingFromStorage(settingData);
    const headers = this.screenStorageKey ? screenSetting?.headers : settingData?.[this.headersStorageKey];
    if (!Array.isArray(headers) || headers.length === 0) return null;
    const storedSortConfig = this.getSortConfigForCurrentScreen(settingData, screenSetting);
    const sortConfig = storedSortConfig ?? cloneDeep(this.sortConfigDefault);
    const functionalTrainingConfig = {
      isSortByRoom: storedSortConfig?.isSortByRoom ?? true,
      isSortByName: storedSortConfig?.isSortByName ?? false,
    }; //function training will have two field seperate to nyusho check-sheet
    const commonConfig = settingData?.nyuShoDisplayConfig ?? new NyuShoDisplayConfigModel();
    return {
      ...settingData,
      headers,
      sortConfig,
      ...(this.isFunctionalTrainingSettingDialog
        ? { nyuShoDisplayConfig: { ...commonConfig,...functionalTrainingConfig,}}  // if this sheet is functional training, will replace sort by functionial training sort
        : {}),
    };
  }

  private prepareSettingForStorage(data: any): any {
    return prepareCheckSheetSettingForStorage({
      data,
      screenStorageKey: this.screenStorageKey,
      headersStorageKey: this.headersStorageKey,
      sortConfigStorageKey: this.sortConfigStorageKey,
      localStorageKey: this.localStorageKey,
      isFunctionalTrainingSettingDialog: this.isFunctionalTrainingSettingDialog,
      isShortTimeSettingDialog: this.isShortTimeSettingDialog,
    });
  }

  private getScreenSettingFromStorage(settingData: any): any {
    return this.screenStorageKey ? settingData?.[this.screenStorageKey] : null;
  }

  private getSortConfigForCurrentScreen(settingData: any, screenSetting: any): any {
    if (this.isShortTimeSettingDialog) {
      return {
        ...(settingData?.sortConfig ?? {}),
        ...(screenSetting?.sortConfig ?? {}),
      };
    }
    return this.screenStorageKey ? screenSetting?.sortConfig : settingData?.[this.sortConfigStorageKey];
  }

  private prepareScreenSettingForStorage(data: any, headers: any[], sortConfig: any): any {
    if (!this.screenStorageKey) {
      return {
        ...data,
        [this.headersStorageKey]: headers,
        [this.sortConfigStorageKey]: sortConfig,
      };
    }

    const {
      [this.screenStorageKey]: screenSetting,
      ...storageData
    } = data;

    return {
      ...storageData,
      [this.screenStorageKey]: {
        ...(screenSetting ?? {}),
        headers,
        sortConfig,
      },
    };
  }

  private getShortTimeSortConfig(sortConfig: any): any {
    return {
      display_order: sortConfig?.display_order,
      time_grouping_flg: sortConfig?.time_grouping_flg,
      sorting_time: sortConfig?.sorting_time,
    };
  }

  private getCommonSortConfig(sortConfig: any): any {
    return {
      unitSelected: sortConfig?.unitSelected ?? [],
      groupSelected: sortConfig?.groupSelected ?? [],
      hidden_overtime_flg: sortConfig?.hidden_overtime_flg ?? false,
      hidden_leave_user: sortConfig?.hidden_leave_user ?? false,
    };
  }

  private getCurrentOfficeScreenSettings(): any {
    const officeCd = this.getSelectedOfficeCd();
    if (!officeCd) return null;

    const allSettings = this.getAllScreenSettings();
    const officeSettings = allSettings[officeCd];
    return this.isPlainObject(officeSettings) ? officeSettings : null;
  }

  private saveCurrentOfficeScreenSettings(settings: Record<string, any>, mode: Mode = Mode.WEB): void {
    const officeCd = this.getSelectedOfficeCd();
    if (!officeCd) return;

    const allSettings = this.getAllScreenSettings();
    allSettings[officeCd] = {
      ...(this.isPlainObject(allSettings[officeCd]) ? allSettings[officeCd] : {}),
      ...settings,
    };

    const allSettingsString = JSON.stringify(allSettings);
    localStorage.setItem(this.localStorageKey, allSettingsString);
    if (this.localStorageKey === LOCAL_STORAGE_KEY.settingDialog) {
      void this.deviceLicensesService.syncSettingConfig();
    }
    if (mode == Mode.TV && (window as any).AndroidBridge?.onWebDialogSave) {
      (window as any).AndroidBridge.onWebDialogSave(allSettingsString);
    }
  }

  private getSelectedOfficeCd(): string | null {
    const officeInfo = sessionStorage.getItem(SESSION_STORAGE_KEY.selectedOfficeIdentity);
    if (!officeInfo) return null;

    try {
      return JSON.parse(officeInfo)?.officeCd ?? null;
    } catch {
      return null;
    }
  }

  private getAllScreenSettings(): Record<string, any> {
    const allSettingsInfo = localStorage.getItem(this.localStorageKey);
    if (!allSettingsInfo) return {};

    try {
      const parsedSettings = JSON.parse(allSettingsInfo);
      return this.isPlainObject(parsedSettings) ? parsedSettings : {};
    } catch {
      return {};
    }
  }

  private isPlainObject(value: unknown): value is Record<string, any> {
    return !!value && typeof value === 'object' && !Array.isArray(value);
  }
}
